import gql from 'graphql-tag'
import { comunicadoFragment } from './comunicado-fragment'

export const comunicadoEnvioFragment = gql`
  fragment ComunicadoEnvioFragment on ComunicadoEnvio {
    id
    lido
    arquivado
    favorito
    comunicado {
      ...ComunicadoFragment
    }
    active
  }
  ${comunicadoFragment}
`
